function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "Capa_2"
},
/*#__PURE__*/
React.createElement("circle", {
  cx: 6.2,
  cy: 13.1,
  r: 2.1
}),
/*#__PURE__*/
React.createElement("circle", {
  cx: 18.1,
  cy: 13.1,
  r: 2.1
}));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M0.2,13.2c0,3.3,2.7,5.9,5.9,5.9c1.5,0,2.9-0.6,4-1.6l1.9,2.1l1.9-2.1c1.1,1,2.5,1.6,4,1.6c3.3,0,5.9-2.7,5.9-5.9 c0-1.7-0.7-3.3-1.9-4.4l1.9-2.1h-4.3c-4.4-3.1-10.4-3.1-15,0H0.2l1.9,2.1C0.9,9.9,0.2,11.5,0.2,13.2z M22.1,13.2c0,2.2-1.8,4-4,4 s-4-1.8-4-4s1.8-4,4-4S22.1,11,22.1,13.2L22.1,13.2z M12.1,6.3c1.5,0,3.1,0.3,4.5,0.9c-2.5,1-4.5,3.2-4.5,5.9c0-2.6-1.9-4.9-4.5-5.9 C9,6.6,10.6,6.3,12.1,6.3z M6.2,9.2c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4C2.1,11,3.9,9.2,6.2,9.2L6.2,9.2L6.2,9.2z"
});

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      version: 1.1,
      id: "Capa_1",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 24 24",
      style: {
        "enableBackground": "new 0 0 24 24"
      },
      xmlSpace: "preserve"
    }, props), _ref, _ref2)
  );
};

export default __webpack_public_path__ + "static/media/tripadvisor.7b3d852f.svg";
export { SvgComponent as ReactComponent };